/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type School from 'linced-app/models/school';

// Proto: finance.StripeConnection.
export default class StripeConnection extends Model {
  declare [Type]: 'finance/stripe-connection';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('number')
  declare createTime: number | undefined;

  @attr('boolean', { defaultValue: false })
  declare isEnabled: boolean;

  @attr('boolean', { defaultValue: false })
  declare isConnected: boolean;

  @attr('boolean', { defaultValue: false })
  declare schoolPaysFees: boolean;

  @attr('boolean', { defaultValue: false })
  declare stripeLiveMode: boolean;

  @attr('string', { defaultValue: '' })
  declare stripeUserId: string;

  @attr('string', { defaultValue: '' })
  declare stripeAuthorizationCode: string;

  @attr('string', { defaultValue: '' })
  declare stripeRefreshToken: string;

  @attr('string', { defaultValue: '' })
  declare stripePublishableKey: string;

  @attr('string', { defaultValue: '' })
  declare reference: string;
}
